import { services } from "../../../../constants";

export default async function authToken() {
  const url = `${this.backendHosts.auth}${services.authToken}`;
  try {
    const response = await this.http.get(url, await this.getHeaders());
    return response;
  } catch (error) {
    this.handleErrorResponse(error);
  }
}
